import futbolkaImg from '../images/aksessuarlar/futbolka.png';
import bayroqImg from '../images/aksessuarlar/bayroq.png';
import kepkaImg from '../images/aksessuarlar/kepka.png';
import krushkaImg from '../images/aksessuarlar/krushka.png';
import ruchkaImg from '../images/aksessuarlar/ruchka.png';

const aksessuarlar = [
  {
    title: 'Futbolka',
    subtitle: '',
    text: 'Futbolkalar hozirgi jamiyatda har bir kishi kiyim javonining ajralmas bo‘lagidir. Ularga o‘z  Tovar belgingiz yoki korxonangiz brendini chop etish orqali siz muvaffaqiyatli reklamaga erisha olasiz. Futbolka, tadbir va yarmarkalar faoliyatini yoritishda ham ular samarali reklama vositasi bo‘lib xizmat qiladi.',
    image: futbolkaImg,
    url: '/product/futbolka',
  },
  {
    title: 'Bayroq',
    subtitle: '',
    text: "Hozirgi kunda bayroqlar ham reklama vositasi sifatida ishlatiladi. Agar ilgari faqat bitta  tashkilot reklama maqsadlarida bayroqlardan foydalangangan bo'lsa, bugungi kunda ulardan  aksariyat joylarda foydalanilayotganligini ko‘rishimiz mumkin. Korxona, tashkilot va turli xil tuzilmalar bayroqlar orqali o‘z brendlari va tovar belgilarini chop  etish orqali samarali yutuqlarga erishmoqdalar.",
    image: bayroqImg,
    url: '/product/bayroq',
  },
  {
    title: 'Bosh',
    subtitle: 'Kiyim',
    fullName: 'Bosh Kiyim',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In faucibus feugiat pharetra massa risus tortor leo. Non viverra tempus metus risus egestas egestas. Elementum eros, sit sapien ullamcorper ullamcorper et eget at. A netus ultrices lectus vitae.',
    image: kepkaImg,
    url: '/product/bosh',
  },
  {
    title: 'Bakal',
    subtitle: '',
    text: 'Bokallarga Tovar belgisi (logotip) tushirish reklama sohasida keng tarqalgan bo‘lib, bu  nafaqat reklamada, balki hamkasblar yoki yaqinlaringizning unutilmas kunlariga munosib sovg‘a ekanligi bilan ham e’tiborlidir.',
    image: krushkaImg,
    url: '/product/bakal',
  },
  {
    title: 'Ruchka',
    subtitle: '',
    text: 'Ma’lumki, ruchkalarga tovar belgisi, mahsulot yoki xizmat ko‘rsatuvchi korxona nom va  brendlarining chop etilishi yangilik emas. Agar ruchkalar kishilar kundalik ehtiyojlarida  ko‘p foydalaniladigan vosita ekanligini hisobga olsak, demakki ular o‘z-o‘zidan reklama sohasida ham o‘ta samarali vositadirlar.',
    image: ruchkaImg,
    url: '/product/ruchka',
  },
];

export default aksessuarlar;
